// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1904px){.container[data-v-6b50f80a]{max-width:1185px}}.w-page-login[data-v-6b50f80a],.w-page-password_reset_confirmation[data-v-6b50f80a],.w-page-register[data-v-6b50f80a]{max-width:700px}.w-block__pre-heading[data-v-6b50f80a]{display:flex;justify-content:center;text-align:center}.v-card[data-v-6b50f80a],.v-sheet[data-v-6b50f80a]{border-radius:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
